import { Grid } from '@mui/material'
import { AppBox, AppButton, AppTypography } from 'components'
import { useMembershipHelper } from 'hooks'
import { FC } from 'react'
import { CancelMembershipType } from '../CancelMembership'

interface Props {
  handleCancelMembershipTyp: (type: CancelMembershipType) => void
}

export const CancelMembershipSelect: FC<Props> = ({ handleCancelMembershipTyp }) => {
  const { IsSoonToBeCancelledUser, IsSoonToBePaused, IsPausedUser, IsCancelledMember } = useMembershipHelper()
  return (
    <AppBox>
      <AppTypography fontSize={32} fontWeight={700} textAlign={'center'}>
        Access all of our features with the plan that fits
      </AppTypography>
      <AppBox display={'flex'} gap={2} paddingX={2} paddingTop={2}>
        <Grid container spacing={2}>
          <Grid item xs={8}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <AppBox
                  borderRadius={4}
                  border={2}
                  borderColor={'grey.300'}
                  padding={1}
                  paddingX={2}
                  display={'flex'}
                  justifyContent={'space-between'}
                  flexDirection={'column'}
                  textAlign={'center'}
                >
                  <AppTypography fontWeight={700} fontSize={32} color={'primary.600'}>
                    Pause
                  </AppTypography>
                  <AppTypography component={'span'} color={'grey.800'} fontSize={14}>
                    Just need a break from your bill?
                  </AppTypography>
                  <AppTypography color={'grey.500'} fontSize={14} paddingTop={4}>
                    Pause your reoccurring subscription plan for up to 6 months by chosing this option.
                  </AppTypography>
                  <AppBox paddingTop={6} alignSelf={'center'}>
                    <AppButton
                      variant="outlined"
                      size="large"
                      onClick={() => handleCancelMembershipTyp(CancelMembershipType.Pause)}
                      sidePaddings={6}
                      disabled={IsSoonToBePaused() || IsPausedUser()}
                    >
                      Select
                    </AppButton>
                  </AppBox>
                </AppBox>
              </Grid>
              <Grid item xs={6}>
                <AppBox
                  borderRadius={4}
                  border={2}
                  borderColor={'grey.300'}
                  padding={1}
                  paddingX={2}
                  display={'flex'}
                  justifyContent={'space-between'}
                  flexDirection={'column'}
                  textAlign={'center'}
                >
                  <AppTypography fontWeight={700} fontSize={32} textAlign={'center'} color={'primary.600'}>
                    Cancel
                  </AppTypography>
                  <AppTypography component={'span'} color={'grey.800'} fontSize={14} textAlign={'center'}>
                    Cancel your subscription?
                  </AppTypography>
                  <AppTypography color={'grey.500'} fontSize={14} paddingTop={4}>
                    Choose to continue canceling your reoccurring subscription plan by selecting this option.
                  </AppTypography>
                  <AppBox paddingTop={6} alignSelf={'center'}>
                    <AppButton
                      variant="outlined"
                      size="large"
                      onClick={() => handleCancelMembershipTyp(CancelMembershipType.Cancel)}
                      sidePaddings={6}
                      disabled={IsSoonToBeCancelledUser() || IsCancelledMember()}
                    >
                      Select
                    </AppButton>
                  </AppBox>
                </AppBox>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={4}>
            <img src={'/images/pax/CancelMembership.png'} alt={'plan1'} />
          </Grid>
        </Grid>
      </AppBox>
    </AppBox>
  )
}
